/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 *
 *
 * NOTE: Hand-added (not regenerated from /api-docs - backend endpoint lives in a parallel
 * session with no live /api-docs yet). Remove this note once a real swagger regen covers it.
 */

export interface AutotagFlagsResponse {
    uiEnabled?: boolean;
}
